<div mat-dialog-title>
  <h2 class="card-title">{{ data.isEditing ? 'Edit' : '' }} Flag Decision #{{ data.decisionNumber }}</h2>
</div>

<mat-dialog-content class="content">
  <mat-form-field appearance="outline" class="reason-flagged">
    <mat-label>Flagged for condition follow-up because:</mat-label>
    <textarea cdkTextareaAutosize [required]="true" matInput [(ngModel)]="data.reasonFlagged"></textarea>
  </mat-form-field>

  <mat-form-field appearance="outline" class="follow-up-at">
    <mat-label>Follow-Up Date</mat-label>
    <input
      matInput
      (click)="followUpAtDatepicker.open()"
      [matDatepicker]="followUpAtDatepicker"
      [(ngModel)]="followUpAt"
    />
    <mat-datepicker-toggle matSuffix [for]="followUpAtDatepicker"></mat-datepicker-toggle>
    <mat-datepicker #followUpAtDatepicker type="date"> </mat-datepicker>
  </mat-form-field>
  <div class="warning">
    <div class="icon">
      <mat-icon>info</mat-icon>
    </div>
    <div class="warning-text">
      <span>Add a follow-up date if:</span>
      <ul class="no-margin-ul">
        <li>the decision is a refusal; or</li>
        <li>there are no End/Due date(s) on the condition(s)</li>
      </ul>
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <div class="button-container">
    <button mat-stroked-button color="primary" [mat-dialog-close]="{ save: false }">Close</button>
    <button mat-flat-button color="primary" type="button" (click)="save()" [disabled]="!data.reasonFlagged">
      Save
    </button>
  </div>
</mat-dialog-actions>
